const antiAliasing = {
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale',
};

// Read the active theme without importing the enum to avoid a mixins <-> env <-> theme import cycle.
const activeTheme =
  (typeof window !== 'undefined' && window._env_ ? window._env_.REACT_APP_THEME : process.env.REACT_APP_THEME) ||
  'enchant';
const isLvs = activeTheme === 'lvs';

// lvs (Tacos and Tequila Festival): primary — Brothers OT; secondary — Acumin Variable Concept.
const fontFamilies = isLvs
  ? {
      primaryLight: 'Brothers OT Regular',
      primaryBold: 'Brothers OT Bold',
      secondaryLight: 'Acumin Variable Concept Regular',
      secondaryBold: 'Acumin Variable Concept Black',
      secondaryBoldWeight: 900,
    }
  : {
      primaryLight: 'Proxima Nova',
      primaryBold: 'Proxima Nova',
      secondaryLight: 'Majesti Banner',
      secondaryBold: 'Majesti Banner',
      secondaryBoldWeight: 700,
    };

const font = {
  primary: {
    light: {
      fontFamily: fontFamilies.primaryLight,
      fontWeight: 400,
      ...antiAliasing,
    },
    bold: {
      fontFamily: fontFamilies.primaryBold,
      fontWeight: 700,
      ...antiAliasing,
    },
  },
  secondary: {
    light: {
      fontFamily: fontFamilies.secondaryLight,
      fontWeight: 400,
      ...antiAliasing,
    },
    bold: {
      fontFamily: fontFamilies.secondaryBold,
      fontWeight: fontFamilies.secondaryBoldWeight,
      ...antiAliasing,
    },
  },
};

export const mixins = {
  font,
};
